// source: compliancepb/transferinput.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var commonpb_file_pb = require('../commonpb/file_pb.js');
goog.object.extend(proto, commonpb_file_pb);
goog.exportSymbol('proto.compliancepb.CreatePendingTransferInputResponse', null, global);
goog.exportSymbol('proto.compliancepb.TransferInput', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.compliancepb.TransferInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.compliancepb.TransferInput.repeatedFields_, null);
};
goog.inherits(proto.compliancepb.TransferInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.compliancepb.TransferInput.displayName = 'proto.compliancepb.TransferInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.compliancepb.CreatePendingTransferInputResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.compliancepb.CreatePendingTransferInputResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.compliancepb.CreatePendingTransferInputResponse.displayName = 'proto.compliancepb.CreatePendingTransferInputResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.compliancepb.TransferInput.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.compliancepb.TransferInput.prototype.toObject = function(opt_includeInstance) {
  return proto.compliancepb.TransferInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.compliancepb.TransferInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.compliancepb.TransferInput.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
submittingParticipantNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
originalReceiverNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
originalDelivererNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
receiverCorrespondent: jspb.Message.getFieldWithDefault(msg, 5, ""),
comments1: jspb.Message.getFieldWithDefault(msg, 6, ""),
comments2: jspb.Message.getFieldWithDefault(msg, 7, ""),
accountIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
delivererAccountNumber: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.compliancepb.TransferInput}
 */
proto.compliancepb.TransferInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.compliancepb.TransferInput;
  return proto.compliancepb.TransferInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.compliancepb.TransferInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.compliancepb.TransferInput}
 */
proto.compliancepb.TransferInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSubmittingParticipantNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOriginalReceiverNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOriginalDelivererNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setReceiverCorrespondent(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setComments1(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setComments2(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addAccountIds(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDelivererAccountNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.compliancepb.TransferInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.compliancepb.TransferInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.compliancepb.TransferInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.compliancepb.TransferInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubmittingParticipantNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOriginalReceiverNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOriginalDelivererNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReceiverCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getComments1();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getComments2();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getDelivererAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string submitting_participant_number = 2;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getSubmittingParticipantNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setSubmittingParticipantNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string original_receiver_number = 3;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getOriginalReceiverNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setOriginalReceiverNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string original_deliverer_number = 4;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getOriginalDelivererNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setOriginalDelivererNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string receiver_correspondent = 5;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getReceiverCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setReceiverCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string comments1 = 6;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getComments1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setComments1 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string comments2 = 7;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getComments2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setComments2 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated string account_ids = 8;
 * @return {!Array<string>}
 */
proto.compliancepb.TransferInput.prototype.getAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setAccountIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.addAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.clearAccountIdsList = function() {
  return this.setAccountIdsList([]);
};


/**
 * optional string deliverer_account_number = 9;
 * @return {string}
 */
proto.compliancepb.TransferInput.prototype.getDelivererAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.TransferInput} returns this
 */
proto.compliancepb.TransferInput.prototype.setDelivererAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.compliancepb.CreatePendingTransferInputResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.compliancepb.CreatePendingTransferInputResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.compliancepb.CreatePendingTransferInputResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.compliancepb.CreatePendingTransferInputResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.compliancepb.CreatePendingTransferInputResponse}
 */
proto.compliancepb.CreatePendingTransferInputResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.compliancepb.CreatePendingTransferInputResponse;
  return proto.compliancepb.CreatePendingTransferInputResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.compliancepb.CreatePendingTransferInputResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.compliancepb.CreatePendingTransferInputResponse}
 */
proto.compliancepb.CreatePendingTransferInputResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.compliancepb.CreatePendingTransferInputResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.compliancepb.CreatePendingTransferInputResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.compliancepb.CreatePendingTransferInputResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.compliancepb.CreatePendingTransferInputResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.compliancepb.CreatePendingTransferInputResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.compliancepb.CreatePendingTransferInputResponse} returns this
 */
proto.compliancepb.CreatePendingTransferInputResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.compliancepb);
